/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { Limits } from '../../../../enums';

import type { RerunConfigParams } from './interfaces';
import type { MiddlewareSteps } from '../../enums';

export class RerunConfig {

    protected readonly limit: number;

    protected step: MiddlewareSteps.Prepare | MiddlewareSteps.Run | null;
    protected counter: number;

    constructor(params: RerunConfigParams) {
        const {
            step = null,
            counter = 1,
            limit = Limits.MaxInteger32,
        } = params;

        this.limit = limit;
        this.counter = counter;
        this.step = step;
    }

    getStep(): MiddlewareSteps.Prepare | MiddlewareSteps.Run | null {
        return this.step;
    }

    setStep(step: MiddlewareSteps.Prepare | MiddlewareSteps.Run | null): void {
        this.step = step;
    }

    getCounter(): number {
        return this.counter;
    }

    incrementCounter(): void {
        this.counter += 1;
    }

    canRerun(): boolean {
        return this.counter < this.limit;
    }

}
